import { useCredits } from '@/hooks/useCredits';

export function CreditsDisplay() {
    const { credits, displayRemaining, displayLimit, planLabel, isLoading } = useCredits();

    if (isLoading || !credits) {
        return null;
    }

    const percentage = displayLimit > 0 ? (displayRemaining / displayLimit) * 100 : 0;
    const isLow = percentage < 20;

    return (
        <div className="flex items-center gap-2 font-mono text-[11px]">
            <span className="uppercase tracking-[0.1em] text-faint">Plan {planLabel}</span>
            <span className="h-1 w-6 bg-surface-3" aria-hidden="true">
                <span
                    className={`block h-full ${isLow ? 'bg-err' : 'bg-foreground'}`}
                    style={{ width: `${Math.max(4, Math.min(100, percentage))}%` }}
                />
            </span>
            <span className={isLow ? 'text-err' : 'text-muted-foreground'}>
                {displayRemaining} restant{displayRemaining > 1 ? 's' : ''}
            </span>
        </div>
    );
}
